import React, { createContext, useContext, useReducer } from "react";

// Contexto
const MaterialUI = createContext();

// Reducer para gerenciar o estado global
const reducer = (state, action) => {
  switch (action.type) {
    case "MINI_SIDENAV": {
      return { ...state, miniSidenav: action.value };
    }
    case "TRANSPARENT_SIDENAV": {
      return { ...state, transparentSidenav: action.value };
    }
    case "WHITE_SIDENAV": {
      return { ...state, whiteSidenav: action.value };
    }
    case "SIDENAV_COLOR": {
      return { ...state, sidenavColor: action.value };
    }
    case "TRANSPARENT_NAVBAR": {
      return { ...state, transparentNavbar: action.value };
    }
    case "FIXED_NAVBAR": {
      return { ...state, fixedNavbar: action.value };
    }
    case "OPEN_CONFIGURATOR": {
      return { ...state, openConfigurator: action.value };
    }
    case "DIRECTION": {
      return { ...state, direction: action.value };
    }
    case "LAYOUT": {
      return { ...state, layout: action.value };
    }
    case "DARKMODE": {
      console.log("Reducer chamado com ação:", { type: "DARKMODE", value: action.value });
      return { ...state, darkMode: action.value };
    }
    case "OPEN_ACCOUNT_MENU": {
      console.log("Reducer chamado com ação:", { type: "OPEN_ACCOUNT_MENU", value: action.value });
      return { ...state, openAccountMenu: action.value };
    }
    case "CURRENCY": {
      console.log("Reducer chamado com ação:", { type: "CURRENCY", value: action.value });
      return { ...state, currency: action.value };
    }
    case "LANGUAGE": {
      console.log("Reducer chamado com ação:", { type: "LANGUAGE", value: action.value });
      return { ...state, language: action.value };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

// Provider para fornecer o contexto a toda a aplicação
const MaterialUIControllerProvider = ({ children }) => {
  const initialState = {
    miniSidenav: false,
    transparentSidenav: false,
    whiteSidenav: false,
    sidenavColor: "info",
    transparentNavbar: true,
    fixedNavbar: true,
    openConfigurator: false,
    direction: "ltr",
    layout: "dashboard",
    darkMode: false,
    openAccountMenu: false,
    currency: "BRL", // Moeda padrão: Real Brasileiro (valores possíveis: "BRL", "USD", "EUR")
    language: "pt", // Idioma padrão: Português (valores possíveis: "pt", "en")
  };

  const [controller, dispatch] = useReducer(reducer, initialState);

  return <MaterialUI.Provider value={[controller, dispatch]}>{children}</MaterialUI.Provider>;
};

// Hook personalizado para acessar o estado e o dispatch
const useMaterialUIController = () => {
  const context = useContext(MaterialUI);
  if (!context) {
    throw new Error("useMaterialUIController should be used inside MaterialUIControllerProvider.");
  }
  return context;
};

// Funções para atualizar o estado
const setMiniSidenav = (dispatch, value) => dispatch({ type: "MINI_SIDENAV", value });
const setTransparentSidenav = (dispatch, value) => dispatch({ type: "TRANSPARENT_SIDENAV", value });
const setWhiteSidenav = (dispatch, value) => dispatch({ type: "WHITE_SIDENAV", value });
const setSidenavColor = (dispatch, value) => dispatch({ type: "SIDENAV_COLOR", value });
const setTransparentNavbar = (dispatch, value) => dispatch({ type: "TRANSPARENT_NAVBAR", value });
const setFixedNavbar = (dispatch, value) => dispatch({ type: "FIXED_NAVBAR", value });
const setOpenConfigurator = (dispatch, value) => dispatch({ type: "OPEN_CONFIGURATOR", value });
const setDirection = (dispatch, value) => dispatch({ type: "DIRECTION", value });
const setLayout = (dispatch, value) => dispatch({ type: "LAYOUT", value });
const setDarkMode = (dispatch, value) => {
  console.log("setDarkMode chamado com valor:", value);
  dispatch({ type: "DARKMODE", value });
};
const setOpenAccountMenu = (dispatch, value) => {
  console.log("setOpenAccountMenu chamado com valor:", value);
  dispatch({ type: "OPEN_ACCOUNT_MENU", value });
};
const setCurrency = (dispatch, value) => {
  console.log("setCurrency chamado com valor:", value);
  dispatch({ type: "CURRENCY", value });
};
const setLanguage = (dispatch, value) => {
  console.log("setLanguage chamado com valor:", value);
  dispatch({ type: "LANGUAGE", value });
};

export {
  MaterialUIControllerProvider,
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  setSidenavColor,
  setTransparentNavbar,
  setFixedNavbar,
  setOpenConfigurator,
  setDirection,
  setLayout,
  setDarkMode,
  setOpenAccountMenu,
  setCurrency,
  setLanguage,
};
